import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const PlaidOnExitEvent = gql`
  mutation PlaidOnExitEvent($input: PlaidOnExitEventInput!) {
    plaidOnExitEvent(input: $input) {
      ... on PlaidOnExitEventSuccess {
        message
      }
      ... on PlaidOnExitEventError {
        ...error
      }
    }
  }
  ${error}
`;
